import { ChangeEvent } from 'react'
import { useDispatch } from 'react-redux'
import { setMassivelyAssign } from '../../../../../../../redux/actions/users'
import { IAddedInputs } from '../../../../../../shared/models/MassAssignmentAddedInputs'
import BrandInterface from '../../../../../brands/models/BrandInterface'
import IFamily from '../../../../../brands/models/FamilyInterface'
import LineInterface from '../../../../../brands/models/LineInterface'
import { BrandVip, LineVip, MassivelyAssign } from './useMassiveAssignState'

type IFilter = {
  family: IFamily | null
  brands: number[]
}

export function useMassiveAssignActions(
  userIds: number[],
  massivelyAssign: any,
  setMassivelyAssignState: any,
  addedInputs: any,
  clearModal: any,
  data: any,
  filters: IFilter
) {
  const dispatch = useDispatch()

  const handleAssignBrand = (brand: BrandInterface, checked: boolean) => {
    let tmpOptions: MassivelyAssign = { ...massivelyAssign }

    let tmpBrands: BrandVip[] = massivelyAssign.brands
    let tmpLines: LineVip[] = massivelyAssign.lines

    brand.active_lines?.forEach((line: LineInterface) => {
      let lineIndex = tmpLines.findIndex((tmpLine: LineVip) => tmpLine.line_id === line.id)
      if (lineIndex >= 0) {
        tmpLines.splice(lineIndex, 1)
      }
    })

    // If true add brand and lines
    if (checked) {
      tmpBrands.push({
        brand_id: brand.id,
        type: 1,
        status: 0
      })
      brand.active_lines?.forEach((line: LineInterface) => {
        tmpLines.push({
          line_id: line.id,
          type: 1,
          status: 0
        })
      })
      tmpOptions.lines = tmpLines
    } else {
      let brandIndex = tmpBrands.findIndex((tmpBrand: BrandVip) => tmpBrand.brand_id === brand.id)
      if (brandIndex >= 0) {
        tmpBrands.splice(brandIndex, 1)
      }
    }
    tmpOptions.brands = tmpBrands

    setMassivelyAssignState(tmpOptions)
  }

  const handleAssignBrandVip = (vipBrand: BrandInterface, checked: boolean) => {
    let tmpOptions: MassivelyAssign = { ...massivelyAssign }

    let tmpBrands: BrandVip[] = massivelyAssign.brands
    let tmpLines: LineVip[] = massivelyAssign.lines

    let brand = tmpBrands.find((tmpBrand: BrandVip) => tmpBrand.brand_id === vipBrand.id)

    if (brand !== undefined) {
      brand.status = Number(checked)
    }

    vipBrand.active_lines?.forEach((lineValue: LineInterface) => {
      let line = tmpLines.find((tmpLine: LineVip) => tmpLine.line_id === lineValue.id)
      if (line !== undefined) {
        line.status = Number(checked)
      }
    })

    tmpOptions.brands = tmpBrands
    tmpOptions.lines = tmpLines

    setMassivelyAssignState(tmpOptions)
  }

  const handleAssignLine = (line: LineInterface, checked: boolean) => {
    let tmpOptions: MassivelyAssign = { ...massivelyAssign }

    let tmpBrands: BrandVip[] = massivelyAssign.brands
    let tmpLines: LineVip[] = massivelyAssign.lines

    // If true add line and brand
    if (checked) {
      // Clear brand if exist
      let brandIndex = tmpBrands.findIndex((tmpBrand: BrandVip) => tmpBrand.brand_id === line.brand_id)
      if (brandIndex < 0) {
        tmpBrands.push({ brand_id: line.brand_id, type: 1, status: 0 })
      }
      tmpLines.push({ line_id: line.id, type: 1, status: 0 })
    } else {
      let lineIndex = tmpLines.findIndex((tmpLine: LineVip) => tmpLine.line_id === line.id)
      if (lineIndex >= 0) {
        tmpLines.splice(lineIndex, 1)
      }
    }
    tmpOptions.brands = tmpBrands

    setMassivelyAssignState(tmpOptions)
  }

  const handleAssignLineVip = (vipLine: LineInterface, checked: boolean) => {
    let tmpOptions: MassivelyAssign = { ...massivelyAssign }

    let tmpBrands: BrandVip[] = massivelyAssign.brands
    let tmpLines: LineVip[] = massivelyAssign.lines

    let line = tmpLines.find((tmpLine: LineVip) => tmpLine.line_id === vipLine.id)

    if (line !== undefined) {
      line.status = Number(checked)
    }

    if (checked) {
      let brand = tmpBrands.find((tmpBrand: BrandVip) => tmpBrand.brand_id === vipLine.brand_id)

      if (brand !== undefined) {
        brand.status = Number(checked)
      }

      tmpOptions.brands = tmpBrands
    }

    tmpOptions.lines = tmpLines

    setMassivelyAssignState(tmpOptions)
  }

  const handleMenuChange = (value: any) => (event: ChangeEvent<HTMLInputElement>) => {
    let checked = event.target.checked
    let tmpOptions: MassivelyAssign = { ...massivelyAssign }

    let tmpOption = tmpOptions.menus
    if (checked) {
      tmpOption.push(value.id)
    } else {
      let indexOption = tmpOption.indexOf(value.id)
      tmpOption.splice(indexOption, 1)
    }
    tmpOptions.menus = tmpOption

    setMassivelyAssignState(tmpOptions)
  }

  const handleSubmit = () => {
    const general: any = addedInputs.map((input: IAddedInputs) => ({
      name: input.name,
      value: data[input.name] !== null ? (data[input.name].id ?? data[input.name]) : null,
      overwrite: input.checked
    }))

    dispatch(setMassivelyAssign({ users: userIds, data: massivelyAssign, brands: filters.brands, general }))
    clearModal()
  }

  return {
    handleAssignBrand,
    handleAssignBrandVip,
    handleAssignLine,
    handleAssignLineVip,
    handleMenuChange,
    handleSubmit
  }
}
